/*
  Component: Product Color Group
  Met à jour le nom affiché à côté du libellé ("Couleur : X") au survol d'une
  vignette, puis le restaure au produit courant quand la souris ressort.

  Délégation au niveau document (un seul bind global, idempotent) pour survivre
  aux re-render partiels de <product-rerender> sur la page produit. Sur les
  appareils tactiles (pas de hover), le libellé reste sur le produit courant.
*/
(function () {
  if (window.__colorGroupBound) return;
  window.__colorGroupBound = true;

  function getItem(target) {
    return target && target.closest ? target.closest('.color-group__item') : null;
  }

  document.addEventListener('mouseover', function (event) {
    var item = getItem(event.target);
    if (!item) return;

    var group = item.closest('.color-group');
    if (!group) return;

    var selected = group.querySelector('.color-group__selected');
    if (selected && item.dataset.name) {
      selected.textContent = item.dataset.name;
    }
  });

  document.addEventListener('mouseout', function (event) {
    var item = getItem(event.target);
    if (!item) return;

    var group = item.closest('.color-group');
    if (!group) return;

    // Ne réinitialise que si on quitte réellement le groupe (pas en passant
    // d'une vignette à une autre du même groupe).
    var related = event.relatedTarget;
    if (related && getItem(related) && getItem(related).closest('.color-group') === group) {
      return;
    }

    var selected = group.querySelector('.color-group__selected');
    if (selected) {
      selected.textContent = selected.dataset.default || '';
    }
  });
})();
